import {Component, inject} from '@angular/core';
import {ActivatedRoute} from '@angular/router';
import {SupportDeskKanbanComponent} from './kanban-board/support-desk-kanban.component';

/**
 * Single scope-aware host for the support desk, replacing the former
 * cross-game / game-admin wrapper pair. Scope is fixed by the route: the global
 * route declares `data: { isCrossGame: true }`, the per-game route (nested under
 * `:gameId`) declares `data: { isCrossGame: false }`. Route data is authoritative
 * and cannot drift the way the mutable active-game selection can on direct URL navigation.
 */
@Component({
  selector: 'app-support-desk',
  standalone: true,
  imports: [SupportDeskKanbanComponent],
  template: '<app-support-desk-kanban [isCrossGameView]="isCrossGame"></app-support-desk-kanban>'
})
export class SupportDeskComponent {
  private route = inject(ActivatedRoute);
  protected readonly isCrossGame = this.route.snapshot.data['isCrossGame'] === true;
}
